var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDistanceIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436 405C436 380.186 415.814 360 391 360C371.47 360 354.976 372.578 348.763 390H163.237C157.024 372.578 140.53 360 121 360C96.186 360 76 380.186 76 405C76 429.459 95.585 450 121 450C141.07 450 157.167 437.183 163.257 420H348.739C354.851 437.274 371.049 450 391 450C416.609 450 436 429.238 436 405Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.358 323.071C111.112 327.393 115.888 330 121 330C126.112 330 130.888 327.393 133.642 323.071L222.177 184.555C234.496 165.293 241 142.969 241 120C241 53.833 187.167 0 121 0C54.833 0 0 53.833 0 120C0 142.969 6.504 165.293 18.823 184.541L108.358 323.071ZM121 60C154.091 60 181 86.909 181 120C181 153.091 154.091 180 121 180C87.909 180 61 153.091 61 120C61 86.909 87.909 60 121 60Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M391 0C324.833 0 271 53.833 271 120C271 142.969 277.504 165.293 289.823 184.541L378.358 323.071C381.112 327.393 385.888 330 391 330C396.112 330 400.888 327.393 403.642 323.071L493.177 184.555C505.496 165.293 512 142.969 512 120C512 53.833 457.167 0 391 0ZM391 180C357.909 180 331 153.091 331 120C331 86.909 357.909 60 391 60C424.091 60 451 86.909 451 120C451 153.091 424.091 180 391 180Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceIcons);
export default __webpack_public_path__ + "static/media/distance-icons.41640c4fafe0a65fe8512d30fea1697b.svg";
export { ForwardRef as ReactComponent };